<template minapp='mpx' xlang='wxml'>
  <image
    wx:if="{{ isImg }}"
    src="{{ name }}"
    mode="aspectFit"
    class="es-icon__image"
    bindtap="handleClick"
  />
  <loading wx:elif="{{name === 'loading' }}" size="{{size}}"></loading>
  <view 
  wx:else 
  class='es-icon custom-class'
  wx:style="{{iconSize}}"
  wx:class="{{iconName}}"
  bindtap="handleClick"
  ></view>

</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  const IMG_REG = /^https?:\/\/(.+\/)+.+(\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif))$/i
  createComponent({
    props: {
      name: String,
      size: {
        type: Number,
        optionalTypes: [String]
      },
      color: String
    },

    computed: {
      isImg() {
        return IMG_REG.test(this.name)
      },

      iconName() {
        return {
          ['es-icon-' + this.name]: true
        }
      },

      iconSize() {
        return {
          fontSize: this.size ? parseFloat(this.size) + 'px' : 'inherit',
          color: this.color || 'inherit'
        }
      }
    },

    methods: {
      handleClick(e) {
        this.$trigger('click', e)
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      loading: './loading'
    }
  }
</script>

